import React from 'react';

export class ResultMessage {
	message: string;
	style: ResultStyle;
	occurred: number;

	constructor(message: string, style: ResultStyle) {
		this.message = message;
		this.style = style;
		this.occurred = new Date().getTime();
	}
}

export enum ResultStyle {
	Info,
	Success,
	Warning,
	Error
}

interface ResultMessageViewProps {
	message: ResultMessage | undefined;
}

interface ResultMessageViewState {
	highlight: boolean;
	timeoutHandle: number;
}

export class ResultMessageView extends React.Component<ResultMessageViewProps, ResultMessageViewState>
{
	private static highlightDelayMs = 800;

	constructor(props: ResultMessageViewProps) {
		super(props);

		this.state = {
			highlight: false,
			timeoutHandle: 0
		};
	}

	public render() {
		if (this.props.message !== undefined) {
			const style = ResultMessageView.getStyleClass(this.props.message.style);
			const highlight = ResultMessageView.getHighlightClass(this.state.highlight);
			const className = 'result-message' + style + highlight;

			return <div className={className}>{this.props.message.message}</div>;
		}

		return null;
	}

	public UNSAFE_componentWillReceiveProps(props: ResultMessageViewProps) {
		if (props.message !== undefined
			&& this.state.timeoutHandle === 0
			&& (
				this.props.message === undefined
				|| props.message.occurred !== this.props.message.occurred
			)) {

			const handler: TimerHandler = () => this.setState({
				highlight: false,
				timeoutHandle: 0
			});

			const handle = setTimeout(handler, ResultMessageView.highlightDelayMs);

			this.setState({
				highlight: true,
				timeoutHandle: handle
			});
		}
	}

	public componentWillUnmount() {
		if (this.state.timeoutHandle !== 0)
			clearTimeout(this.state.timeoutHandle);
	}

	private static getStyleClass(style: ResultStyle): string {
		switch (style) {
			case ResultStyle.Info: return ' rm-info';
			case ResultStyle.Success: return ' rm-success';
			case ResultStyle.Warning: return ' rm-warning';
			case ResultStyle.Error: return ' rm-error';
		}
	}

	private static getHighlightClass(highlight: boolean) {
		return highlight ? ' highlight' : '';
	}
}
